import React, { Component } from 'react';
//import { NavLink } from "react-router-dom"
import { authentication } from '../services/Authentication';

import moment from 'moment';
import helpers from '../Function';
import { config } from '../Constants';

import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalFooter from "react-bootstrap/ModalFooter";
import ModalTitle from "react-bootstrap/ModalTitle";

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';

import Checkbox from '@material-ui/core/Checkbox';

import { Editor } from '@tinymce/tinymce-react';
import $ from "jquery"

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import { Scrollbars } from 'react-custom-scrollbars';
import LoadingOverlay from 'react-loading-overlay';

export default class JuristicMessageBox extends Component {

    constructor(props) {
        super(props);
        const { name, user_id, jwt, user_type, user_permission } = authentication.currentUserValue;

        this.state = {
            apiKey: process.env.TINY,
            pages: [],
            blog_type_pages: [{ value: '', display: 'เลือกประเภท' }, { value: 'blog', display: 'Blog' }, { value: 'news', display: 'News' }],
            userid: user_id,
            user_permission: user_permission,
            content_id: '',
            src_house_no: '',
            src_category: '',
            src_project: '',
            src_owner: '',
            src_phone: '',
            jwt: jwt,
            create_by: name,
            create_by_id: user_id,
            usertype: user_type,
            addIsOpen: false,
            srcIsOpen: false,
            updateIsOpen: false,
            dgNotiIsOpen: false,
            active: true,
            add_id: '',
            add_title: '',
            add_content: '',
            add_detail: '',
            add_active_status: '',
            add_file: '',
            add_send_date: '',
            add_send_status: 0,
            add_create_date: '',
            add_project: '',
            add_usertype: '',
            add_file: '',
            value: "content",
            status: '1',
            src_content: false,
            file: null,
            page: 0,
            rowsPerPage: 10,
            miss_su: helpers.getUserType(user_type, "su"),
            member_list: [],
            dataSend: [],
            project_home: [],
            send_id: '',
            disSubmit: true,
            isActiveLoading: false,
        };

        $("#root").addClass("wrapper");
        $("body").removeClass("login-page");

        this.dataTable = this.dataTable.bind(this);

        this.closeAdd = this.closeAdd.bind(this);
        this.closeModelUpdate = this.closeModelUpdate.bind(this);
        this.openAdd = this.openAdd.bind(this);
        this.openView = this.openView.bind(this);
        this.submitAdd = this.submitAdd.bind(this);

        this.change = this.change.bind(this);
        this.openEdit = this.openEdit.bind(this);
        this.submitEdit = this.submitEdit.bind(this);
        this.openSrc = this.openSrc.bind(this);
        this.submitSrc = this.submitSrc.bind(this);
        this.closeSrc = this.closeSrc.bind(this);

        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
        this.handleChange = this.handleChange.bind(this)
        this.handleCheck = this.handleCheck.bind(this)
        this.onChange = this.onChange.bind(this);


        this.openDelete = this.openDelete.bind(this);
        this.closeDelete = this.closeDelete.bind(this);
        this.submitDelete = this.submitDelete.bind(this);


        this.handleActiveSrcCheck = this.handleActiveSrcCheck.bind(this)
        this.handleNonActiveSrcCheck = this.handleNonActiveSrcCheck.bind(this)
        this.handleContentSrcCheck = this.handleContentSrcCheck.bind(this)
        this.handleLinkSrcCheck = this.handleLinkSrcCheck.bind(this)

        this.openNoti = this.openNoti.bind(this)
        this.closeNoti = this.closeNoti.bind(this)
        this.submitNoti = this.submitNoti.bind(this)
        this.onCheckbok = this.onCheckbok.bind(this)
        this.openDgNoti = this.openDgNoti.bind(this)
        this.closeDgNoti = this.closeDgNoti.bind(this)
        this.initPJHone = this.initPJHone.bind(this)

        this.dataTable()
        this.initPJHone()

    }

    componentDidMount() {
        helpers.checklogin(this.state.jwt);
    }

    initPJHone() {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/project_homes', requestOptions)
                .then(res => res.json())
                .then(data => {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    var sortData = data.data.sort(function (a, b) {
                        return a.num - b.num;
                    });
    
                    var found = sortData.filter(function (item) { return item.active; });
                    var found2 = found.filter(function (item) { return !item.delete; });
    
                    var FromApi = found2.map(data => {
                        return { value: data.id, display: data.name_th }
                    });
    
                    this.setState({
                        project_home: [].concat(FromApi)
                    });
    
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    change(e) {
        this.setState({
            [e.target.name]: e.target.value
        });

        try {
            if (e.target.name == "add_group") {
                this.setState({
                    member_list: []
                });
                if (e.target.value == "project") {
                    $("#by_project").show();
                    $("#by_type").hide();
                } else if (e.target.value == "type") {
                    $("#by_project").hide();
                    $("#by_type").show();
                } else if (e.target.value == "all") {
                    $("#by_project").hide();
                    $("#by_type").hide();
                    this.setState({
                        isActiveLoading: true
                    });
                    const requestOptions = {
                        method: 'GET',
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': this.state.jwt,
                        },
                    };
    
                    const body = `?token_notification='-'&token_notification=''&user_type=owner,install,live,renter`
                    fetch(config.url.API_URL + '/membersMessageBox/' + body, requestOptions)
                        .then(res => res.json())
                        .then(dataMain => {
                            var data = dataMain.data
                            
                            var FromApi = data.map(datas => {
                                return {
                                    id: datas.id,
                                    user_type: datas.user_type,
                                    phone: datas.phone,
                                    member_name: datas.member_name,
                                    house_no: datas.owner_home,
                                    token_notification: datas.token_notification,
                                    device_type: datas.device_type,
                                    device_number: datas.device_number,
                                    notice_status: datas.notice,
                                    residence_id: datas.residence_id
                                }
                            });
    
                            this.setState({
                                member_list: [].concat(FromApi)
                            });
                            this.setState({
                                isActiveLoading: false
                            });
                        }).catch(error => {
                            console.log(error)
                            //window.location.reload(); // Reload the page
                        });
                }
            } else if (e.target.name == "add_project") {
                this.setState({
                    isActiveLoading: true
                });
                const requestOptions = {
                    method: 'GET',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': this.state.jwt,
                    },
                };
    
                const body = `?token_notification='-'&token_notification=''&projecthomeid=` + e.target.value
                fetch(config.url.API_URL + '/membersMessageBox/' + body, requestOptions)
                    .then(res => res.json())
                    .then(dataMain => {
                        var data = dataMain.data
                        
                        var FromApi = data.map(datas => {
                            return {
                                id: datas.id,
                                user_type: datas.user_type,
                                phone: datas.phone,
                                member_name: datas.member_name,
                                house_no: datas.owner_home,
                                token_notification: datas.token_notification,
                                device_type: datas.device_type,
                                device_number: datas.device_number,
                                notice_status: datas.notice,
                                residence_id: datas.residence_id
                            }
                        });
    
                        this.setState({
                            member_list: [].concat(FromApi)
                        });
                        this.setState({
                            isActiveLoading: false
                        });
                    }).catch(error => {
                        console.log(error)
                        //window.location.reload(); // Reload the page
                    });
            } else if (e.target.name == "add_usertype") {
                this.setState({
                    isActiveLoading: true
                });
                const requestOptions = {
                    method: 'GET',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': this.state.jwt,
                    },
                };
    
                const body = `?token_notification='-'&user_type=` + e.target.value
                fetch(config.url.API_URL + '/membersMessageBox/' + body, requestOptions)
                    .then(res => res.json())
                    .then(dataMain => {
                        var data = dataMain.data
                        
                        var FromApi = data.map(datas => {
                            return {
                                id: datas.id,
                                user_type: datas.user_type,
                                phone: datas.phone,
                                member_name: datas.member_name,
                                house_no: datas.owner_home,
                                token_notification: datas.token_notification,
                                device_type: datas.device_type,
                                device_number: datas.device_number,
                                notice_status: datas.notice,
                                residence_id: datas.residence_id
                            }
                        });
    
                        this.setState({
                            member_list: [].concat(FromApi)
                        });
                        this.setState({
                            isActiveLoading: false
                        });
                    }).catch(error => {
                        console.log(error)
                        //window.location.reload(); // Reload the page
                    });
            }
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    submitAdd() {
        try {
            if (!this.state.add_title) {
                alert('ไม่พบข้อมูลหัวเรื่อง');
                return;
            }
    
            if (!this.state.add_content) {
                alert('ไม่พบคำย่อ');
                return;
            }
    
            if (!this.state.add_detail && this.state.value === 'content') {
                alert('ไม่พบข้อมูลเนื้อหา');
                return;
            }
    
            const formData = new FormData();
            formData.append('title', this.state.add_title);
            formData.append('content', this.state.add_content);
            formData.append('detail', this.state.add_detail);
            formData.append('active', this.state.active);
            formData.append('createby', this.state.create_by);
            formData.append('createby_id', this.state.create_by_id);
            formData.append('myFile', this.state.file);
    
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Authorization': this.state.jwt,
                },
                body: formData
            };
    
            fetch(config.url.API_URL + '/messagebox', requestOptions)
                .then(res => res.json())
                .then(data => {
                    this.setState({
                        updateIsOpen: true
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
    
            this.setState({ addIsOpen: false });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    dataTable() {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/messagebox', requestOptions)
                .then(res => res.json())
                .then(data => {
                    if (Array.isArray(data.data) && data.data.length) {
    
                        var FromApi = data.data.map(datas => {
                            return {
                                id: datas._id,
                                title: datas.title,
                                content: datas.content,
                                send_status: datas.send_status,
                                send_statusname: datas.send_status == '1' ? "ส่งแล้ว" : "ยังไม่ส่ง",
                                send_date: (datas.send_date ? moment(datas.send_date).format('DD/MM/YYYY HH:mm น.') : ''),
                                create_date: moment(datas.created).format('DD/MM/YYYY HH:mm น.'),
                                active_status: datas.active_status,
                                updateby: datas.updateby == undefined ? datas.createby : datas.updateby,
                                updated: datas.updated != undefined ? `${moment(datas.updated).format("DD/MM/YYYY HH:mm น.")}` : `${moment(datas.created).format("DD/MM/YYYY HH:mm น.")}`,
                            }
                        });
    
                        this.setState({
                            pages: [].concat(FromApi)
                        });
    
                    } else {
                        this.setState({
                            pages: []
                        });
                    }
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    openAdd() {
        this.setState({
            add_title: '',
            add_content: '',
            add_detail: '',
            add_active_status: '',
            value: 'content',
            active: true,
            addIsOpen: true,
            methodOpen: 'add'
        });
    }

    openView(e) {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/messagebox/' + e.currentTarget.attributes["data-id"].value, requestOptions)
                .then(res => res.json())
                .then(dataDetail => {
                    var data = dataDetail.data;
    
                    this.setState({
                        add_id: data._id,
                        add_title: data.title,
                        add_detail: data.detail,
                        add_content: data.content,
                        add_active_status: data.active_status == '1' ? "ใช้งาน" : "ไม่ได้ใช้งาน",
                        add_send_date: moment(data.send_date).format("DD/MM/YYYY"),
                        add_create_date: moment(data.send_date).format("DD/MM/YYYY"),
                        add_file: data.file,
                        add_send_status: data.send_status,
                    });
    
                    this.setState({
                        addIsOpen: true,
                        methodOpen: 'view'
                    });
    
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    openDelete(e) {
        this.setState({
            deleteIsOpen: true,
            content_id: e.currentTarget.attributes["data-id"].value
        });
    }

    submitDelete(e) {
        try {
            const requestOptions = {
                method: 'DELETE',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    updateby: this.state.create_by,
                    updateby_id: this.state.create_by_id
                }),
            };
    
            fetch(config.url.API_URL + '/messagebox/' + this.state.content_id, requestOptions)
                .then(res => res.json())
                .then(data => {
                    this.setState({
                        updateIsOpen: true
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
    
            this.setState({ deleteIsOpen: false });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }


    closeDelete() {
        this.setState({ deleteIsOpen: false });
        this.dataTable();
    }

    closeAdd() {
        this.setState({ addIsOpen: false });
    }

    openEdit(e) {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/messagebox/' + e.currentTarget.attributes["data-id"].value, requestOptions)
                .then(res => res.json())
                .then(dataDetail => {
                    var data = dataDetail.data;
    
                    this.setState({
                        add_id: data._id,
                        add_title: data.title,
                        add_detail: data.detail,
                        add_content: data.content,
                        active: data.active_status,
                        add_send_date: moment(data.send_date).format("DD/MM/YYYY"),
                        add_create_date: moment(data.send_date).format("DD/MM/YYYY"),
                        add_file: data.file,
                        add_send_status: data.send_status,
                    });
    
                    this.setState({
                        addIsOpen: true,
                        methodOpen: 'edit'
                    });
    
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    Capitalize(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    submitEdit(e) {
        try {
            const formData = new FormData();
            formData.append('id', this.state.add_id);
            formData.append('title', this.state.add_title);
            formData.append('content', this.state.add_content);
            formData.append('active_status', this.state.active ? 1 : 0)
            formData.append('detail', this.state.add_detail);
            formData.append('updateby', this.state.create_by);
            formData.append('updateby_id', this.state.create_by_id);
            formData.append('myImage', this.state.file);
            const requestOptions = {
                method: 'PUT',
                headers: {
                    'Authorization': this.state.jwt,
                },
                body: formData
            };
    
            fetch(config.url.API_URL + '/messagebox/' + e.currentTarget.attributes["data-id"].value, requestOptions)
                .then(res => res.json())
                .then(data => {
                    this.setState({
                        updateIsOpen: true
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
    
            this.setState({ addIsOpen: false });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    closeSrc() {
        this.setState({ srcIsOpen: false });
    }

    closeModelUpdate() {
        this.setState({
            updateIsOpen: false,
            dataSend: []
        });
        this.dataTable();
    }

    submitSrc(e) {
        this.dataTableSrc()
        this.setState({ srcIsOpen: false });
    }

    openSrc(e) {
        this.setState({
            srcIsOpen: true,
            src_content: '',
            add_title: '',
            add_content: '',
            add_sendtype: '',
            page: 0
        });
    }

    dataTableSrc() {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            var body = `?active=${this.state.src_active}&nonactive=${this.state.src_nonactive}&title=${this.state.add_title}&content=${this.state.add_content}&send_status=${this.state.add_sendtype}`
    
            fetch(config.url.API_URL + '/messagebox' + body, requestOptions)
                .then(res => res.json())
                .then(data => {
                    if (Array.isArray(data.data) && data.data.length) {
    
                        var FromApi = data.data.map(datas => {
                            return {
                                id: datas._id,
                                title: datas.title,
                                content: datas.content,
                                send_status: datas.send_status,
                                send_statusname: datas.send_status == '1' ? "ส่งแล้ว" : "ยังไม่ส่ง",
                                send_date: (datas.send_date ? moment(datas.send_date).format('DD/MM/YYYY HH:mm น.') : ''),
                                create_date: moment(datas.created).format('DD/MM/YYYY HH:mm น.'),
                            }
                        });
    
                        this.setState({
                            pages: [].concat(FromApi)
                        });
    
                    } else {
                        this.setState({
                            pages: []
                        });
                    }
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    handleChangePage(event, newPage) {
        this.setState({
            page: newPage
        });
    };

    handleChangeRowsPerPage(event) {
        //alert(event.target.value)
        this.setState({
            page: 0,
            rowsPerPage: parseInt(event.target.value)
        });
    };

    handleChange(event) {
        this.setState({ add_detail: event.target.value });
    }

    changeStartDate = date => {
        this.setState({
            add_start_date: date
        });
    }

    changeEndDate = date => {
        this.setState({
            add_end_date: date
        });
    }

    handleCheck() {
        this.setState({ active: !this.state.active });
    }

    onChange(e) {
        this.setState({ file: e.target.files[0] });
    }

    handleEditorChange = (content, editor) => {
        this.setState({
            add_detail: content
        });
        console.log('Content was updated:', content);
    }

    handleEditorBlur = async (content, editor) => {
        const data = await editor.getContent();
        this.setState({
            add_content: data
        });
        console.log('Content was updated:', data);

    }

    handleContentTypeChange = (event) => {
        this.setState({
            value: event.target.value
        })
    };

    handleActiveSrcCheck() {
        this.setState({
            src_active: !this.state.src_active
        });
    }

    handleNonActiveSrcCheck() {
        this.setState({
            src_nonactive: !this.state.src_nonactive
        });
    }

    handleContentSrcCheck() {
        this.setState({
            src_content: !this.state.src_content
        });
    }

    handleLinkSrcCheck() {
        this.setState({
            src_link: !this.state.src_link
        });
    }

    openNoti(e) {
        this.setState({
            notiIsOpen: true,
            send_id: e.currentTarget.attributes["data-id"].value,
            member_list: [],
            dataSend: []
        });
    }

    closeNoti() {
        this.setState({
            notiIsOpen: false,
            send_id: '',
            disSubmit: true
        });
    }

    submitNoti(e) {
        try {
            const requestOptions = {
                method: 'PUT',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    send_list: this.state.dataSend,
                    updateby: this.state.create_by,
                    updateby_id: this.state.create_by_id,
                }),
            };
            console.log(this.state.dataSend)
            
            fetch(config.url.API_URL + '/messagebox/' + this.state.send_id, requestOptions)
                .then(res => res.json())
                .then(data => {
                    this.setState({
                        updateIsOpen: true
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
            this.setState({ dgNotiIsOpen: false });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    openDgNoti(e) {
        this.setState({
            dgNotiIsOpen: true,
            notiIsOpen: false,
        });
    }

    closeDgNoti() {
        this.setState({
            dgNotiIsOpen: false,
            send_id: '',
            disSubmit: true
        });
    }

    async onCheckbok(e) {
        try {
            var member_list = this.state.member_list
            if (e.target.value == "all") {
                this.setState({
                    dataSend: []
                })
    
                if (e.target.checked) {
                    var Obj = this.state.dataSend;
                    await $("input[type=checkbox]").each(function () {
                        //const result = Obj.find(({ id }) => id === $(this).val());
                        const result = Obj.find(({ residence_id }) => residence_id === $(this).val());
    
                        ($(this).val() != "all" && $(this).click())
    
                        if ($(this).val() != "all" && result === undefined) {
                            const datas = member_list.find(({ residence_id }) => residence_id === $(this).val());
                            //const datas = member_list.find(({ id }) => id === $(this).val());
                            Obj.push({
                                member_id: datas.id,
                                user_type: datas.user_type,
                                member_name: datas.member_name,
                                house_no: datas.house_no,
                                token_notification: datas.token_notification,
                                device_type: datas.device_type,
                                device_number: datas.device_number,
                                notice_status: datas.notice_status,
                                residence_id: datas.residence_id
                            })
                        }
                    });
    
                    this.setState({
                        dataSend: Obj
                    })
                } else {
                    await $("input[type=checkbox]").each(function () {
                        ($(this).val() != "all" && $(this).click())
                    })
                }
            } else {
                
                if (e.target.checked) {
                    const result = this.state.dataSend.find(({ residence_id }) => residence_id === e.target.value);
                    if (result === undefined) {
                        const datas = member_list.find(({ residence_id }) => residence_id === e.target.value);
                        console.log("=======JSON.stringify(datas)========" + JSON.stringify(datas))
                        this.state.dataSend.push({
                            member_id: datas.id,
                            user_type: datas.user_type,
                            member_name: datas.member_name,
                            house_no: datas.house_no,
                            token_notification: datas.token_notification,
                            device_type: datas.device_type,
                            device_number: datas.device_number,
                            notice_status: datas.notice_status,
                            residence_id: datas.residence_id
                        })
                        /*id: datas.id, 
                        user_type: datas.user_type, 
                        member_name: datas.member_name, 
                        house_no: datas.owner_home,
                        token_notification: datas.token_notification,
                        device_type: datas.device_type,
                        device_number: datas.device_number, */
                    }
                } else {
                    var i = this.state.dataSend.findIndex(residence_id => residence_id === e.target.value);
                    this.state.dataSend.splice(i, 1);
                }
            }
            if (this.state.dataSend.length) {
                this.setState({
                    disSubmit: false
                })
            } else {
                this.setState({
                    disSubmit: true
                })
            }
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    render() {

        const StyledTableCell = withStyles(theme => ({
            head: {
                backgroundColor: "#E8EFF5",
                color: "#212529",
                fontSize: 20,
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                textAlign: 'center',
            },
            body: {
                fontSize: 18,
                verticalAlign: 'text-top',
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                padding: 8,
            },
        }))(TableCell);

        const StyledTableRow = withStyles(theme => ({
            root: {
                '&:nth-of-type(odd)': {
                    backgroundColor: theme.palette.background.default,
                },
            },
        }))(TableRow);

        const emptyRows = this.state.rowsPerPage - Math.min(this.state.rowsPerPage, this.state.page.length - this.state.page * this.state.rowsPerPage);
        const renderHTML = (escapedHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: escapedHTML } });

        return (
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0 text-dark">Juristic Message</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item active">juristic message</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="content">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="btn-advance text-center" onClick={this.openSrc}>ค้นหาขั้นสูง</div>
                                    {(this.state.user_permission[79].permission == 1 && <div className="btn-add text-center" onClick={this.openAdd}>เพิ่มข้อมูล</div>)}
                                </div>
                                <div className="card-body">
                                    <TableContainer component={Paper}>
                                        <Table aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell style={{ width: 'auto' }}>No</StyledTableCell>
                                                    <StyledTableCell style={{ width: '20%' }}>หัวเรื่อง</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>คำย่อ</StyledTableCell>
                                                    <StyledTableCell style={{ width: '10%' }}>วันที่ส่ง</StyledTableCell>
                                                    <StyledTableCell style={{ width: '10%' }}>สถานะการส่ง</StyledTableCell>
                                                    <StyledTableCell style={{ width: '10%' }}>วันที่สร้าง</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>อัพเดทล่าสุด</StyledTableCell>
                                                    <StyledTableCell style={{ width: '140px' }}>รายละเอียด</StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    this.state.pages.slice(this.state.page * this.state.rowsPerPage,
                                                        this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((data, i) => {
                                                            return (
                                                                <StyledTableRow key={`1${i}`}>
                                                                    <StyledTableCell>{i + 1}</StyledTableCell>
                                                                    <StyledTableCell>{data.title}</StyledTableCell>
                                                                    <StyledTableCell>{renderHTML(data.content)}</StyledTableCell>
                                                                    <StyledTableCell>{data.send_date}</StyledTableCell>
                                                                    <StyledTableCell>{data.send_statusname}</StyledTableCell>
                                                                    <StyledTableCell>{data.create_date}</StyledTableCell>
                                                                    {data.updateby != undefined && <StyledTableCell>{data.updateby}<br />{data.updateby == undefined ? data.updated : data.updated}</StyledTableCell>}
                                                                    {data.updateby == undefined && <StyledTableCell>{data.updated}</StyledTableCell>}
                                                                    <StyledTableCell>
                                                                        {((this.state.user_permission[82].permission == 1 && data.send_status == 0 && data.active_status == 1) && <button className="btn-action text-center" data-id={data.id} onClick={this.openNoti}><i className="far fa-paper-plane" ></i> &nbsp;&nbsp;Send</button>)}
                                                                        <button className="btn-action text-center" data-id={data.id} onClick={this.openView}><img src="dist/img/icon/ic_view.png" className="btn-icon" alt="" /> View</button>
                                                                        {((this.state.user_permission[80].permission == 1 && data.send_status == 0) &&
                                                                            <button className="btn-action text-center" data-id={data.id} onClick={this.openEdit}><img src="dist/img/icon/ic_update.png" className="btn-icon" alt="" /> Update</button>
                                                                        )}
                                                                        {((this.state.user_permission[81].permission == 1) &&
                                                                            <button className="btn-action text-center" data-id={data.id} onClick={this.openDelete}><img src="dist/img/icon/ic_del.png" className="btn-icon" alt="" /> Delete</button>
                                                                        )}
                                                                    </StyledTableCell>
                                                                </StyledTableRow>)
                                                        })
                                                }

                                                {emptyRows > 0 && (
                                                    <StyledTableRow>
                                                        <StyledTableCell colSpan={6} />
                                                    </StyledTableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            rowsPerPageOptions={[10, 25, 50]}
                                            component="div"
                                            count={this.state.pages.length}
                                            rowsPerPage={this.state.rowsPerPage}
                                            page={this.state.page}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        />
                                    </TableContainer>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Modal show={this.state.addIsOpen} onHide={this.closeAdd} size="xl" enforceFocus={false}>
                    <ModalHeader>
                        <ModalTitle>{(this.state.methodOpen === 'add' && "เพิ่มข้อมูล") || (this.state.methodOpen === 'edit' && "แก้ไขข้อมูล") || (this.state.methodOpen === 'view' && "ตรวจสอบข้อมูล")}</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-submit">
                            <div className="row mb-3">
                                <div className="col-sm-2 text-right">หัวเรื่อง<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-7">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<input type="text" className="form-control" id="add_title" name="add_title" defaultValue={this.state.add_title} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_title}</div>)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-2 text-right">คำย่อ<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-7">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<TextareaAutosize className="form-control" name="add_content" rowsMin={2} defaultValue={this.state.add_content} onChange={this.change} />)
                                        : (<TextareaAutosize className="form-control" name="add_content" rowsMin={2} defaultValue={this.state.add_content} disabled />)}
                                </div>
                            </div>
                            {(this.state.value === 'content') ? (<div className="row mb-3">
                                <div className="col-sm-2 text-right">เนื้อหา<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-9">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<Editor
                                            apiKey={this.state.apiKey}
                                            initialValue={this.state.add_detail}
                                            init={{
                                                width: 'auto',
                                                height: 300,
                                                plugins: [
                                                    "autoresize",
                                                    'advlist autolink link image lists preview',
                                                    'searchreplace wordcount visualblocks visualchars code media emoticons',
                                                    'table template paste help'
                                                ],
                                                toolbar: 'undo redo | styleselect | emoticons | bold italic | alignleft aligncenter alignright alignjustify | ' +
                                                    'bullist numlist outdent indent | link image | preview media | ' +
                                                    'forecolor backcolor | help',
                                                menubar: 'edit view insert format tools table',  // change this value according to your HTML
                                                automatic_uploads: true,
                                                images_upload_handler: function (blobInfo, success, failure) {
                                                    var xhr, formData;
                                                    xhr = new XMLHttpRequest();
                                                    xhr.withCredentials = false;
                                                    xhr.open('POST', `${config.url.API_URL}/uploadImage/`);
                                                    xhr.onload = function () {
                                                        var json;

                                                        if (xhr.status !== 200) {
                                                            failure('HTTP Error: ' + xhr.status);
                                                            return;
                                                        }
                                                        json = JSON.parse(xhr.responseText);

                                                        if (!json || typeof json.location != 'string') {
                                                            failure('Invalid JSON: ' + xhr.responseText);
                                                            return;
                                                        }
                                                        success(json.location);
                                                    };
                                                    formData = new FormData();
                                                    formData.append('myImage', blobInfo.blob());
                                                    xhr.send(formData);
                                                },
                                                content_css: '//www.tiny.cloud/css/codepen.min.css',
                                                autoresize_on_init: false,
                                                autoresize_overflow_padding: 10
                                            }}
                                            // onEditorChange={this.handleEditorChange}
                                            onBlur={this.handleEditorBlur}
                                        />)
                                        : (<Editor
                                            apiKey={this.state.apiKey}
                                            initialValue={this.state.add_detail}
                                            init={{
                                                width: 'auto',
                                                height: 300,
                                                plugins: [
                                                    "autoresize",
                                                    'advlist autolink link image lists preview',
                                                    'searchreplace wordcount visualblocks visualchars code media emoticons',
                                                    'table template paste help'
                                                ],
                                                toolbar: 'undo redo | styleselect | emoticons | bold italic | alignleft aligncenter alignright alignjustify | ' +
                                                    'bullist numlist outdent indent | link image | preview media | ' +
                                                    'forecolor backcolor | help',
                                                menubar: 'edit view insert format tools table',
                                                content_css: '//www.tiny.cloud/css/codepen.min.css',
                                                autoresize_on_init: false,
                                                autoresize_overflow_padding: 10
                                            }}
                                            // onEditorChange={this.handleEditorChange}
                                            onBlur={this.handleEditorBlur}
                                            disabled={true}
                                        />)}
                                </div>
                            </div>) : (
                                    <div className="row mb-3">
                                        <div className="col-sm-2 text-right">link<span style={{ color: 'red' }}>*</span></div>
                                        <div className="col-sm-3">
                                            {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                                (<input type="text" className="form-control" id="add_link" name="add_link" defaultValue={this.state.add_link} onChange={this.change} />)
                                                : (<div className="form-control">{this.state.add_link}</div>)}
                                        </div>
                                    </div>)
                            }
                            {/* <div className="row mb-3">
                                <div className="col-sm-2 text-right">ไฟล์แนบ<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-9">
                                    <div>{(this.state.add_file && <a href={this.state.add_file}>ดาวห์โหลดเอกสารตัวอย่าง</a>)}</div>
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') &&
                                        (<input type="file" name="myImage" onChange={this.onChange} />)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-2"></div>
                                <div className="col-sm-5"><span style={{ color: 'red', fontSize: '18px' }}>*หมายเหตุ : รองรับไฟล์ขนาดไม่เกิน 20 MB เฉพาะไฟล์ JPG,PNG</span></div>
                            </div> */}
                            <div className="row mb-3">
                                <div className="col-sm-2 text-right">สถานะ<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-5">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<p><Checkbox
                                            checked={this.state.active}
                                            onChange={this.handleCheck}
                                            color="primary"
                                        />ใช้งาน</p>)
                                        : (<div>
                                            <p>{this.state.add_active_status}</p>
                                        </div>)}
                                </div>
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        {(this.state.methodOpen === 'add' &&
                            (<div><button className="btn btn-danger" onClick={this.closeAdd}>ยกเลิก</button>&nbsp;&nbsp;
                                <button className="btn btn-success" onClick={this.submitAdd}>เพิ่มข้อมูล</button></div>))
                            || (this.state.methodOpen === 'edit' &&
                                (<div><button className="btn btn-danger" onClick={this.closeAdd}>ยกเลิก</button>&nbsp;&nbsp;
                                    <button className="btn btn-warning" data-id={this.state.add_id} onClick={this.submitEdit}>แก้ไขข้อมูล</button></div>))
                            || (this.state.methodOpen === 'view' &&
                                (<div><button className="btn btn-success" onClick={this.closeAdd}>ตกลง</button></div>))}
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.notiIsOpen} onHide={this.closeNoti} size="lg">
                    <ModalHeader>
                        <ModalTitle>ส่งข้อความแจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-serach">
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right" >เลือกกลุ่ม :</div>
                                <div className="col-sm-5">
                                    <select className="form-control" name="add_group" onChange={this.change}>
                                        <option value="">เลือกกลุ่ม</option>
                                        <option value="all">เลือกทุกกลุ่ม</option>
                                        <option value="project">เลือกตามโครงการ</option>
                                        <option value="type">เลือกตามกลุ่มผู้ใช้งาน</option>
                                    </select>
                                </div>
                            </div>

                            <div className="row mb-3" id="by_project" style={{ display: "none" }}>
                                <div className="col-sm-3 text-right">เลือกตามโครงการ :</div>
                                <div className="col-sm-5">
                                    <select className="form-control" name="add_project" onChange={this.change}>
                                        <option value="">โปรดเลือกตามโครงการ</option>
                                        {this.state.project_home.map(datas => {
                                            return (<option value={datas.value}>{datas.display}</option>)
                                        })}
                                    </select>
                                </div>
                            </div>

                            <div className="row mb-3" id="by_type" style={{ display: "none" }}>
                                <div className="col-sm-3 text-right">เลือกตามกลุ่มผู้ใช้งาน :</div>
                                <div className="col-sm-5">
                                    <select className="form-control" name="add_usertype" onChange={this.change}>
                                        <option value="">โปรดเลือกตามกลุ่มผู้ใช้งาน</option>
                                        <option value="guest">บุคคลทั่วไป</option>
                                        <option value="normal">สมาชิกระบบทั่วไป</option>
                                        <option value="social">สมาชิกจากโซเชียล</option>
                                        <option value="owner">เจ้าของบ้าน</option>
                                        <option value="live">ผู้อยู่อาศัย</option>
                                        <option value="install">ผ่อนดาวน์</option>
                                    </select>
                                </div>
                            </div>
                            {/*return (val === 'owner' && "เจ้าของบ้าน") ||
                                (val === 'guest' && "ชมโครงการ") ||
                                (val === 'live' && "ผู้อยู่อาศัย") ||
                                (val === 'install' && "ผ่อนดาวน์") ||*/}
                            <div className="row mb-3">
                                <div className="col-sm-12" style={{ padding: "0px 20px" }}>
                                    <LoadingOverlay active={this.state.isActiveLoading} spinner text='Loading...' >
                                        <Scrollbars style={{ height: 350 }}>
                                            <table id="myTable" className="table table-bordered" >
                                                <thead className="table-base">
                                                    <tr>
                                                        <th scope="col" style={{ width: '1%' }}><input type="checkbox" id="chkAll" className="chk" value="all" onClick={this.onCheckbok} /></th>
                                                        <th scope="col" style={{ width: '5%' }}>No</th>
                                                        <th scope="col" >ประเภทกลุ่ม</th>
                                                        <th scope="col" >เลขที่บ้าน</th>
                                                        <th scope="col" >เบอร์โทรศัพท์</th>
                                                        <th scope="col" >ชื่อ-นามสกุล</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {/*{id: datas.id, user_type: datas.user_type, member_name: datas.member_name, house_no: datas.owner_home}*/}
                                                    {(this.state.member_list && this.state.member_list.map((datas, i) => {
                                                        return (<tr>
                                                            <td><input type="checkbox" onClick={this.onCheckbok}
                                                                value={datas.residence_id} /></td>
                                                            <td>{i + 1}</td>
                                                            <td>{helpers.getMemberType(datas.user_type)}</td>
                                                            <td>{datas.house_no}</td>
                                                            <td>{datas.phone}</td>
                                                            <td>{datas.member_name}</td>
                                                        </tr>)
                                                    }))
                                                    }

                                                </tbody>
                                            </table>
                                        </Scrollbars>
                                    </LoadingOverlay>
                                </div>
                            </div>
                        </form>

                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeNoti}>ยกเลิก</button>&nbsp;&nbsp;
                        <button className="btn btn-info" onClick={this.openDgNoti} disabled={this.state.disSubmit}>ส่งข้อมูลแจ้งเตือน</button>
                    </ModalFooter>
                </Modal>

                <Modal show={this.state.srcIsOpen} onHide={this.closeSrc} size="lg">
                    <ModalHeader>
                        <ModalTitle>ค้นหาขั้นสูง</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-serach">
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">หัวเรื่อง</div>
                                <div className="col-sm-5">
                                    <input type="text" className="form-control" id="add_title" name="add_title" defaultValue={this.state.add_title} onChange={this.change} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">คำย่อ</div>
                                <div className="col-sm-5">
                                    <input type="text" className="form-control" id="add_content" name="add_content" defaultValue={this.state.add_content} onChange={this.change} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">สถานะการส่ง :</div>
                                <div className="col-sm-5">
                                    <select className="form-control" name="add_sendtype" onChange={this.change}>
                                        <option value="">โปรดเลือกสถานะการส่ง</option>
                                        <option value="1">ส่งแล้ว</option>
                                        <option value="0">ยังไม่ได้ส่ง</option>
                                    </select>
                                </div>
                            </div>
                            <div className="row mb-3" >
                                <div className="col-sm-3 text-right">สถานะ</div>
                                <div className="col-sm-5">
                                    <Checkbox
                                        checked={this.state.src_active}
                                        onChange={this.handleActiveSrcCheck}
                                        color="primary"
                                    /> ใช้งาน
                                    <Checkbox
                                        checked={this.state.src_nonactive}
                                        onChange={this.handleNonActiveSrcCheck}
                                        color="primary"
                                    /> ไม่ได้ใช้งาน
                                </div>
                            </div>
                        </form>

                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeSrc}>ยกเลิก</button>&nbsp;&nbsp;
                        <button className="btn btn-success" onClick={this.submitSrc}>ค้นหาข้อมูล</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.updateIsOpen} onHide={this.closeModelUpdate} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        บันทึกรายการสำเร็จ
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-success" onClick={this.closeModelUpdate}>ตกลง</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.deleteIsOpen} onHide={this.closeDelete} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        ยืนยันการลบรายการหรือไม่
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeDelete}>ยกเลิก</button>&nbsp;&nbsp;
                        <button className="btn btn-warning" onClick={this.submitDelete}>ยืนยัน</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.dgNotiIsOpen} onHide={this.closeDgNoti} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        ยืนยันการส่งรายการแจ้งเตือนนี้หรือไม่
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeDgNoti}>ยกเลิก</button>&nbsp;&nbsp;
                        <button className="btn btn-info" onClick={this.submitNoti}>ยืนยัน</button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}